import type { components } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';

export type LeagueContext = NonNullable<
  components['schemas']['ContextResponse']['data']
>;

export const fetchLeagueContext = async (): Promise<LeagueContext | null> => {
  const { data, error } = await ffhClient().GET('/league/context', {});

  if (error) throw new Error('Failed to load league context');
  return data?.data ?? null;
};
